import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
type Props = {
  viewHeight: string;
};

const colors = appPalette.colors;
function styleScroll() {
  return {
    '&::-webkit-scrollbar': {
      width: '0.375rem',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: colors.light_grey_2,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: colors.mid_grey,
    },
  };
}

export const useStyles = makeStyles({
  paper: {
    maxHeight: (props: Props) => props.viewHeight,
    width: '100vw',
    overflow: 'scroll',
    position: 'relative',
    backgroundColor: 'white',
    border: '0',
    outline: 'none',
    padding: '1rem 2rem 0 2rem',
    [theme.breakpoints.up('viewportMobileMid')]: {
      margin: '0 auto',
      maxWidth: '87.5rem',
      maxHeight: '90.625rem',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '1rem 2rem 2.5rem 2rem',
      backgroundColor: 'white',
      border: '0',
    },
  },
  modal_data: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '0',
    height: 'auto',
    maxHeight: (props: Props) => `calc(${props.viewHeight} - 3rem)`,
    paddingBottom: '2rem',
    ...styleScroll(),
    [theme.breakpoints.up('viewportMedium')]: {
      height: 'auto',
      maxHeight: 'calc(20rem - 6.25rem)',
      paddingBottom: '0',
    },
  },
  copy_button: {
    '& svg': {
      margin: 'auto 0 auto 0.5rem',
      height: '0.75rem',
      width: 'auto',
    },
    padding: 0,
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    textTransform: 'uppercase',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  copy: {
    '& svg': {
      margin: 'auto 0 auto 0.5rem',
      height: '0.75rem',
      width: 'auto',
    },
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    textTransform: 'uppercase',
  },
  button_group: {
    marginTop: '2.5rem',
    display: 'flex',
  },
  confirmation_button: {
    width: '9.375rem',
    height: '2.5rem',
    textTransform: 'uppercase',
    boxSizing: 'border-box',
    '&:first-child': {
      backgroundColor: 'transparent',
      border: '0.0625rem black solid',
      marginRight: '0.5rem',
      [theme.breakpoints.up('viewportMedium')]: {
        marginRight: '1rem',
      },
    },
    '&:last-child': {
      backgroundColor: colors.acura_red,
      border: 'none',
      color: colors.white,
      marginLeft: '0.5rem',
      [theme.breakpoints.up('viewportMedium')]: {
        marginLeft: '1rem',
      },
    },
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      width: '12rem',
    },
  },
});
